<template>
  <div class="full-view">
    <b-container>
      <b-row>
        <b-col sm="12" md="6" offset-md="3" class="mt-5 content-center">
          <h4>Authentication</h4>
          <p>The content of this website is currently under construction and protected. Please enter password to continue.</p>
          <b-alert v-if="show_password_warning" show variant="danger">Inccorect password, please try again</b-alert>
          <b-form-input v-model="password" type="password"> </b-form-input>
          <b-button class="mt-2" @click="submit_password">Submit</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      show_password_warning:false
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.is_logged_in;
    },
  },
  methods: {
    submit_password() {
      this.$store.commit("set_password", this.password);
      if (this.isLoggedIn) {
        this.$router.push("/home");
      }
      else{
        this.show_password_warning = true;
        this.password = "";
      }
    },
  },
};
</script>